import {call, put, select, takeLatest} from 'redux-saga/effects'
import Api from './DocumentSearchApi'
import * as actions from "./actions";
import * as selectors from './selectors'
import {getQueryParamValue, HISTORY} from "../util/History";
import {SAGA_INIT_SEARCH} from "./actions";
import {SAGA_NEXT_SEARCH_PAGE} from "./actions";
import {Saga} from "./actions";
import {getSubscriptions} from "../subscription/saga.js";

import * as errorActions from "./../error/actions";

import * as userSelectors from "./../user/selectors";
import {Saga as userSaga} from "../user/actions";
import {INTERNAL_DOCUMENT_SEARCH_PATH, PUBLIC_DOCUMENT_SEARCH_PATH} from "../ajax/sdgOnlinePaths";
import {updateQueryString, makeParam} from "./../util/History";
import {ValidationError} from "../util/errors";

const SEARCH_TERM_PARAM = "searchTerm";
const PAGE_NUMBER_PARAM = "pageNumber";

export function* initialiseSearch() {
  try {
    const oldSearchTerm = getQueryParamValue(SEARCH_TERM_PARAM);
    const oldPageNumberStr = getQueryParamValue(PAGE_NUMBER_PARAM);

    let oldPageNumber;

    if (oldPageNumberStr) {
      oldPageNumber = Number.parseInt(oldPageNumberStr, 10);
      oldPageNumber = Number.isNaN(oldPageNumber) ? 0 : oldPageNumber;
    }

    if (oldSearchTerm) {
      yield put(actions.Saga.setSearchTerm(oldSearchTerm, oldPageNumber))
    }
  }
  catch (e) {
    yield put(errorActions.Saga.setError(e));
  }
}

function* setSearchTerm({searchTerm, pageNumber = 0}) {
  try {
    yield put(actions.Generator.setLoadingSearch(true));
    yield put(actions.Generator.setSearch(searchTerm, pageNumber));
    yield call(getSubscriptions);
    yield put(actions.Generator.clearResults());
    yield put(Saga.loadNextSearchPage(pageNumber));
  }
  catch (e) {
    yield put(errorActions.Saga.setError(e));
  }
}

function* loadNextPage(action) {
  try {

    const searchTerm = yield select(selectors.getSearchTerm)
    const historyState = HISTORY.location.state;

    const isLoggedin = yield select(userSelectors.isLoggedIn);

    yield put(userSaga.setUser());
    const searchFunc = isLoggedin ? Api.doSearch : Api.doPublicSearch;

    const pathToUse = (isLoggedin ? INTERNAL_DOCUMENT_SEARCH_PATH : PUBLIC_DOCUMENT_SEARCH_PATH);
    const updatedQueryString = updateQueryString(HISTORY.location.search, [makeParam(SEARCH_TERM_PARAM, searchTerm), makeParam(PAGE_NUMBER_PARAM, action.pageNo)]);
    HISTORY.replace(pathToUse + "?" + updatedQueryString);

    if (searchTerm && searchTerm.length > 0) {

      try {
        const searchResults = yield call(searchFunc, searchTerm, action.pageNo);
        yield put(actions.Generator.setMoreResults(searchResults.data))
      }
      catch (e) {
        if (e instanceof ValidationError)
        {
          yield put(actions.Generator.setSearchTermErrors(e))
        }
        else {
          throw e;
        }
      }

    }
    else {
      //clear the results
      yield put(actions.Generator.clearResults());
    }

    //restore the old scroll position if there is one
    if (historyState) {
      const {scrollTop} = historyState;
      if (scrollTop) {
        window.scroll(0, scrollTop);
      }
    }

    yield put(actions.Generator.setLoadingSearch(false));
  }
  catch (e) {
    yield put(actions.Generator.setLoadingSearch(false));
    yield put(errorActions.Saga.setError(e));
  }
}

function* documentSaga() {
  yield takeLatest(actions.SAGA_SET_SEARCH_TERM, setSearchTerm);
  yield takeLatest(actions.SAGA_DOCUMENT_SEARCH_REQUESTED, loadNextPage);
  yield takeLatest(SAGA_INIT_SEARCH, initialiseSearch);
  yield takeLatest(SAGA_NEXT_SEARCH_PAGE, loadNextPage)
}

export default documentSaga;